import { Router } from '@angular/router';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '@web/base/shared/components/base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from '../../menu-item.model';

@Component({
  selector: 'menu-header-item',
  templateUrl: './menu-header-item.component.html',
  styleUrls: ['./menu-header-item.component.scss']
})
export class MenuHeaderItemComponent extends BaseComponent implements OnInit {

  @Input() items: MenuItem[];
  @Output() flyoutStateChange = new EventEmitter<boolean>();

  // Item cuyo submenu lateral esta abierto. En este componente llamamos "flyout"
  // al submenu de otro nivel que sale hacia un lado, fuera del bloque con scroll.
  public activeFlyoutItem: MenuItem;

  // Orden de posiciones que CDK prueba para colocar el submenu lateral.
  // Primero intenta abrirlo a la derecha del item; si no cabe, prueba abajo o a la izquierda.
  public flyoutPositions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
      offsetX: 0
    },
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'bottom',
      offsetX: 0
    },
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'top',
      offsetX: 0
    },
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'bottom',
      offsetX: 0
    }
  ];

  private closeFlyoutTimeout: any;

  constructor(
    public translate: TranslateService,
    public router: Router
  ) {
    super(translate);
  }

  ngOnInit() {
    this.getTranslations(['menu']);
  }

  // Abre el submenu lateral del item indicado y avisa al menu principal
  // para que no se cierre mientras el usuario navega ese submenu.
  openFlyout(item: MenuItem) {
    if (!item?.children?.length) {
      return;
    }

    this.clearCloseFlyoutTimeout();
    this.activeFlyoutItem = item;
    this.flyoutStateChange.emit(true);
  }

  // Programa el cierre con un pequeno retraso. Sin esta pausa, al mover el raton
  // desde "Circulares" hasta el submenu lateral, el menu se cerraria antes de llegar.
  scheduleCloseFlyout(item?: MenuItem) {
    this.clearCloseFlyoutTimeout();

    this.closeFlyoutTimeout = setTimeout(() => {
      if (!item || this.activeFlyoutItem === item) {
        this.closeFlyout();
      }
    }, 180);
  }

  // Cierra el submenu lateral abierto y avisa al menu principal
  // para que pueda quitar la clase que mantenia visible el primer submenu.
  closeFlyout() {
    this.clearCloseFlyoutTimeout();
    this.activeFlyoutItem = null;
    this.flyoutStateChange.emit(false);
  }

  // Si en el futuro hay mas niveles, este metodo hace que su estado abierto/cerrado
  // llegue hasta el primer item del menu de cabecera.
  propagateFlyoutState(isOpen: boolean) {
    this.flyoutStateChange.emit(isOpen);
  }

  closeMenu(submenu) {
    this.closeFlyout();
    submenu.style.pointerEvents = 'none';
    setTimeout(() => {
      submenu.style.pointerEvents = 'auto';
    }, 500);
  }

  // Cancela un cierre pendiente si el usuario vuelve a entrar en el item o en el panel lateral.
  private clearCloseFlyoutTimeout() {
    if (this.closeFlyoutTimeout) {
      clearTimeout(this.closeFlyoutTimeout);
      this.closeFlyoutTimeout = null;
    }
  }
}
